<!-- Projected content lives in ONE template: inside the agent shell this
     instance is a pass-through (`inline`, see the component), outside it
     renders the full frame around the content. -->
<ng-template #projected><ng-content></ng-content></ng-template>

@if (inline) {
<ng-container [ngTemplateOutlet]="projected"></ng-container>
} @else {
<div class="page-header">
  <!-- Orbi statt Identitäts-Kachel und Play-Button (Marcel, 28.09.2026):
       im Ruhezustand "Try me", bei Hover/Fokus wird er zum Play-Button
       (Lab-Sequenz `play-button`), Klick startet bzw. beendet den
       Vorschau-Chat. Der Agent-Name bleibt als unsichtbare Seitenüberschrift. -->
  <h2 class="agent-heading">{{ tutor?.visual_name || tutor?.name }}</h2>
  <app-orbi-lab
    [type]="orbType"
    [size]="72"
    [script]="headerOrbiScript"
    [playStop]="true"
    [active]="isChatActive"
    (playRequest)="startChat()"
    (stopRequest)="stopChat()"
    [nbTooltip]="
      (isChatActive
        ? 'components.dashboardHeader.stopTutor'
        : 'components.dashboardHeader.startTutor'
      ) | translate
    "
    nbTooltipPlacement="bottom"
  ></app-orbi-lab>
</div>

<div class="content">
  <nb-card class="menu-card">
    <nb-menu [items]="items"></nb-menu>
  </nb-card>
  <div class="form-container">
    <!-- Schließen: zurück zur Agentenliste. Liegt oben rechts auf der
         Konfigurationskarte, auf Höhe ihres Titels ("Allgemein", "Wissen" …),
         als Relief-Plakette aus dem CI-Paket (wie die Ordner in der
         Wissensbasis); Hover färbt rot (Marcel, 28.09.2026). -->
    <a
      class="close-config al-relief-icon al-relief-icon--large al-icon--close"
      [routerLink]="['/tutors']"
      [attr.aria-label]="'buttons.close' | translate"
      [nbTooltip]="'buttons.close' | translate"
      nbTooltipPlacement="left"
    ><span class="al-relief-glyph" aria-hidden="true"></span></a>
    @if(loading){
    <app-page-loader></app-page-loader>
    }@else {
    <ng-container *ngIf="tutor" [ngTemplateOutlet]="projected"></ng-container>
    }
  </div>
</div>
}
